import React, {memo} from 'react'
import cx from 'classnames'

/* Components */
import HbImageView from '../../../../../components/HbImage/view/HbImageView'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../../modules/analytics/davinci/davinciConstants'

/* Utils */
import DataSet from '../../../../../utils/DataSet'

/* Styles */
import s from './css-carousel-badges.scss'

const CssCarouselBadges = memo((
  {
    pageTypeForDavinci,
    hasVideo,
    videoBadgeOnClick,
    sku,
    componentViewEventData,
    imageBadge
  }) => {

  const handleSendVideoClickEvent = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      page_type: pageTypeForDavinci,
      page_value: sku,
      location: 'image',
      text: 'Video',
      placement: 'button',
      position: '',
      url: ''
    })
  }

  return (
    <>
      {
        imageBadge &&
        <HbImageView
          className={s.incentiveToBuyBadge}
          image={{
            alt: imageBadge?.text,
            src: imageBadge?.imageUrl,
          }}/>
      }
      {
        hasVideo &&
        <div
          data-hbus={
            DataSet.createComponentViewDataForDavinci({
              placement: 'image',
              component: 'video button',
              componentDetail: 'Video Buttonu',
              ...componentViewEventData,
            })}
          className={cx(s.videoBadge, s.bottomRight)}
          onClick={() => {
            handleSendVideoClickEvent()
            videoBadgeOnClick()
          }}
          data-test-id={'video-badge'}>
          <i className={s.icon}/>
          <span className={s.text}>
            {'Video'}
          </span>
        </div>
      }
    </>
  )
})

export default CssCarouselBadges
